export interface BankDropdownActionType {
  type: BankDropdown;
  payload?: any;
}

export enum BankDropdown {
  GET_BANK_DROPDOWN_LIST = "GET_BANK_DROPDOWN_LIST",
  SET_BANK_DROPDOWN_LIST = "SET_BANK_DROPDOWN_LIST",
  SET_BANK_DROPDOWN_LOADING = "SET_BANK_DROPDOWN_LOADING",
}
